import {
  getUsuarios,
  getUsuario,
  deleteUsuario,
  editUsuario,
  createUsuario,
  resetPassword,
} from "../../../helpers/backend_helper";
import {
  apiError,
  usuariosSuccess,
  usuarioSuccess,
  usuariosDeleteSuccess,
  reset_usuario_flag,
} from "./reducer";

export const cambiarPassword = (usuario) => async (dispatch) => {
  try {
    const response = resetPassword(usuario);
    const data = await response;    

    if (data) {
      const serializableData = {
        data: data.data,
        message: data.message,
        status: data.status,
      };
      dispatch(usuarioSuccess(serializableData));
    }

  } catch (error) {
    dispatch(apiError(error.message));
  }
};

export const getUsers = () => async (dispatch) => {
  try {
    const response = getUsuarios();
    const data = await response;

    if (data) {
      const serializableData = {
        data: data.data,
        message: data.message,
        status: data.status,
      };
      dispatch(usuariosSuccess(serializableData));
    }
  } catch (error) {
    dispatch(apiError(error.message));
  }
};

export const getUser = (id) => async (dispatch) => {
  try {
    const response = getUsuario(id);
    const data = await response;

    if (data) {
      const serializableData = {
        data: data.data,
        message: data.message,
        status: data.status,
      };
      dispatch(usuarioSuccess(serializableData)); 
    }
  } catch (error) {

    dispatch(apiError(error.message));
  }
};

export const deleteUser = (id) => async (dispatch) => {
  try {
    const response = deleteUsuario(id);
    const data = await response;
    if (data) {
      const serializableData = {
        data: data.data,
        message: data.message,
        status: data.status,
      };
      dispatch(usuariosDeleteSuccess(serializableData));
    }
  } catch (error) {
    dispatch(apiError(error.message));
  }
};

export const editUser = (usuario) => async (dispatch) => {
  try {
    const response = editUsuario(usuario);
    const data = await response;
    if (data) {
      const serializableData = {
        data: data.data,
        message: data.message,
        status: data.status,
      };
      dispatch(usuarioSuccess(serializableData));
    }
  } catch (error) {
    dispatch(apiError(error.message));
  }
};

export const createUser = (usuario) => async (dispatch) => {
  try {
    const response = createUsuario(usuario);
    const data = await response;

    if (data) {
      const serializableData = {
        data: data.data,
        message: data.message,
        status: data.status,
      };
      dispatch(usuarioSuccess(serializableData));
    }
  } catch (error) {


    dispatch(apiError(error.message));
  }
};

export const resetUsuarioFlag = () => async (dispatch) => {
  try {
    const response = dispatch(reset_usuario_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error.message));
  }
};
